import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';

import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';

import { CollaborationNotesComponent } from './collaboration-notes/collaboration-notes.component';
import { CrmTaskPanelComponent } from './crm-task-panel/crm-task-panel.component';
import { ActivityFeedComponent } from './activity-feed/activity-feed.component';
import { MentionInputComponent } from './mention-input/mention-input.component';
import { DelegationPanelComponent } from './delegation-panel/delegation-panel.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatMenuModule,
    MatChipsModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatBadgeModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatListModule,
    CustomFlexLayoutModule,
    // Standalone components
    CollaborationNotesComponent,
    CrmTaskPanelComponent,
    ActivityFeedComponent,
    MentionInputComponent,
    DelegationPanelComponent
  ],
  exports: [
    CollaborationNotesComponent,
    CrmTaskPanelComponent,
    ActivityFeedComponent,
    MentionInputComponent,
    DelegationPanelComponent
  ]
})
export class CollaborationModule {}
